import authReducer from '../modules/Admin/User/Login/store/reducer';
import userMetaReducer from '../layouts/layoutComponents/sidebar/store/reducer'

export default function rootReducer(state, action) {
    return {
        auth: authReducer(state.auth, action),
        userMeta: userMetaReducer(state.userMeta, action)
    }
}
